import { Provider } from '@angular/core';

import { GeographyRepositoryImpl } from '@app/data/repositories/geography/geography.repository';
import { GEOGRAPHY_REPOSITORY } from '@app/domain/repositories/geography/geography.repository.contract';

export const geographyRepositoryProvider: Provider = {
  provide: GEOGRAPHY_REPOSITORY,
  useClass: GeographyRepositoryImpl
};
